import { Box, IconButton, Paper, Typography } from '@mui/material';
import React from 'react';
import { IoMdClose } from 'react-icons/io';

import { AttachedFileProps } from './types';

export const AttachedFile: React.FC<AttachedFileProps> = ({ filename, onRemove }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        borderRadius: '4px',
        marginBottom: '8px',
        marginLeft: '10px',
      }}
    >
      <Paper
        sx={{
          display: 'flex',
          alignItems: 'center',
          padding: '8px',
          backgroundColor: '#f1f1f1',
          borderRadius: '4px',
        }}
      >
        <Typography variant="body2" sx={{ marginRight: '8px' }}>
          {filename}
        </Typography>
        <IconButton size="small" onClick={onRemove}>
          <IoMdClose />
        </IconButton>
      </Paper>
    </Box>
  );
};
